<app-timeline
    class="flex h-full min-h-0 w-full flex-col"
    *ngIf="readyToLoadAcivityStream"
    [actorId]="actorId"
    [targetId]="targetId"
    [objectId]="objectId"
    [displayOptions]="displayOptions"
    [autoloadItems]="false"
/>
